import React from "react"
import styled from "@emotion/styled"

import Next from "../../images/clients/next.svg"
import RoyalMail from "../../images/clients/royal-mail.svg"
import Lloyds from "../../images/clients/lloyds.svg"
import YHA from "../../images/clients/YHA.svg"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 96px 0;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  display: grid;
  text-align: center;
  color: ${props => props.theme.shade[20]};
`
const Client = styled.img`
  height: 60px;
  max-width: 240px;
  margin-left: auto;
  margin-right: auto;
  height: ${props => props.height};
`
const ClientGrid = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 64px;
  align-items: center;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-auto-flow: row;
    margin-top: 32px;
  }
`

export default function Clients() {
  return (
    <Outer>
      <Inner>
        <p>We work with start-ups, SMEs and FTSE 100 businesses</p>
        <ClientGrid>
          <Client src={Next} alt="Next Logo" height="50px" />
          <Client src={RoyalMail} alt="Royal Mail Logo" height="80px" />
          <Client src={Lloyds} alt="Lloyds Logo" height="60px" />
          <Client src={YHA} alt="YHA Logo" height="70px" />
        </ClientGrid>
      </Inner>
    </Outer>
  )
}
